import React from 'react'
import { fieldBoxShadow } from './FormTextInput'

interface FormSuffixInputProps {
  value: string
  onChange: (value: string) => void
  placeholder: string
  suffix: string
  error?: boolean
}

const FormSuffixInput = ({
  value,
  onChange,
  placeholder,
  suffix,
  error = false
}: FormSuffixInputProps): JSX.Element => {
  return (
    <div
      className="self-stretch h-11 pl-4 bg-backgrounds-bg-field-component rounded-md inline-flex justify-center items-center gap-1 overflow-hidden"
      style={{ boxShadow: fieldBoxShadow(error) }}>
      <input
        type="text"
        inputMode="numeric"
        value={value}
        onChange={(event) => {
          onChange(event.target.value)
        }}
        placeholder={placeholder}
        className="flex-1 h-full bg-transparent outline-none text-foregrounds-fg-base text-sm font-semibold font-Montserrat leading-5 placeholder:text-foregrounds-fg-muted placeholder:font-semibold"
      />
      <div className="w-11 self-stretch px-2 py-1 border-l border-borders-border-base inline-flex flex-col justify-center items-center overflow-hidden">
        <div className="text-center text-foregrounds-fg-base text-xs font-medium font-Montserrat leading-5">
          {suffix}
        </div>
      </div>
    </div>
  )
}

export default FormSuffixInput
